import { ArrowDropDownIcon } from "@mui/x-date-pickers";
import { MenuItem, Select } from "@mui/material";
// import Label from "@/components/Common/Label";
// import { apiRequest } from "@/utils/config/apiRequest";
import { DOC_STATUS, DOCTYPE, LABEL_TYPE } from "../../utils/Constant";
import { apiRequest } from "../../utils/config/apiRequest";
import Label from "./Label";

export const StatusHandler = ({
  payload,
  endPoint,
  value,
  statusConstant,
  labelType,
  method,
  params,
  riderDocType = '',
  shopKeeperDocType = '',
  onChange = () => { },
  ...rest
}) => {
  const handleStatusChange = async (e) => {
    let status = e.target.value;
    const newPayload = { ...payload }

    if (labelType === LABEL_TYPE.DOC_STATUS ) {
      if (riderDocType === 'idCheck') {
        newPayload.idCheck = status === DOC_STATUS.VERIFIED
      }
      if (riderDocType === 'vehicleCheck') {
        newPayload.vehicleCheck = status === DOC_STATUS.VERIFIED
      }
      if (riderDocType === 'addressCheck') {
        newPayload.addressCheck = status === DOC_STATUS.VERIFIED
      }
      if (riderDocType === 'isBgCheck') {
        newPayload.isBgCheck = status === DOC_STATUS.VERIFIED
      }
      else if ([DOCTYPE.DOCUMENT, DOCTYPE.ID_PROOF]?.includes(shopKeeperDocType)) {
        newPayload.status = status
      }
    }
    const apiResp = await apiRequest({
      endUrl: endPoint,
      body: { ...newPayload, status },
      method: method,
      ...(params && { params }),
      showMsg: true,
    });
    if (apiResp?.status) {
      onChange(e);
    }
  };

  return (
    <Select
      fullWidth
      size="small"
      value={value}
      disableUnderline
      variant="standard"
      onChange={handleStatusChange}
      renderValue={(value) => (
        <Label type={labelType} color={"success"} value={value}>
          {value?.replace(/_/g," ")} <ArrowDropDownIcon />
        </Label>
      )}
      inputProps={{ IconComponent: () => null }}
      {...rest}
    >
      {Object.entries(statusConstant).map(([_, value]) => {
        return (
          <MenuItem
            value={value}
            key={value}
            sx={{ textTransform: "capitalize" }}
          >
            {value?.replace(/_/g," ")}
          </MenuItem>
        );
      })}
    </Select>
  );
};
